export const visit = (vm, at) => {
at({ "en": { "conversations-inbox-message-history": { "context-update-message": { "ENTRY_URL": "Chatting from: {{ value }}", "CUSTOM": "{{value}}", "CHATFLOW": "Chatting from chat flow: {{ value }}" } } } });
};